import { render, staticRenderFns } from "./CRMProjectView.vue?vue&type=template&id=5cb65c5d"
import script from "./CRMProjectView.vue?vue&type=script&lang=js"
export * from "./CRMProjectView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports